import { useSystemSettings } from '@beeriot/api-client';
import { useThresholdColorProcessor } from './useThresholdColorProcessor';

export function useThresholdColor(systemId: string | undefined | null) {
  const { data } = useSystemSettings(systemId);
  const colorProcessor = useThresholdColorProcessor(data);
  return colorProcessor;
}
